import OrderedList from '@tiptap/extension-ordered-list';
import { makeSyncMenu, makeToggleListCommand } from './_list_helpers';

const syncMenu = makeSyncMenu('orderedList', 'ordered');

export default [
  OrderedList.extend({
    addCommands: makeToggleListCommand('toggleOrderedList'),
    addAttributes() {
      return {
        start: {
          default: 1,
          parseHTML: (element) => {
            return element.hasAttribute('start')
              ? parseInt(element.getAttribute('start') || '', 10)
              : 1;
          },
        },
        type: {
          default: null,
          parseHTML: (element) => element.getAttribute('type'),
        },
      };
    },
    onSelectionUpdate: syncMenu,
    onTransaction({ editor }) {
      syncMenu({ editor });
    },
  }),
];
